<template>
  <NuxtLink v-slot="{ navigate }" to="/war-room/categories/deal_story/posts" custom>
    <span class="deal-story-badge" @click="navigate">
      <span class="deal-story-badge__icon"><IconStar /></span>
      Deal Story
    </span>
  </NuxtLink>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'DealStoryBadge',
  components: { IconStar: () => import('./assets/star.vue.svg') },
});
</script>

<style lang="scss" scoped>
.deal-story-badge {
  color: var(--blue-60);

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  &__icon {
    vertical-align: middle;
    display: inline-block;
  }
}
</style>
